// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @ helpers
const { formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');

// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('commonsComponents/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ components
const InsuranceRequestCoverageDetailModal = require('../insuranceRequestCoverageDetail/insuranceRequestCoverageDetailModal');

// @ constants
const { EURO_TEXT } = require('constants/index');
const { PLANS: { BASIC }, PROPERTY_USAGE: { RENT }, NA } = require('../../../insuranceConstants/insuranceRequestHome');

// @ actions
const insuranceRequestWizardActions = require('../../../actions/insuranceRequest/insuranceRequestWizard');

class InsuranceRequestProductHomeDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDetailsModal: false
        };

        this.handleToggleDetailsModal = this.handleToggleDetailsModal.bind(this);
    }

    handleToggleDetailsModal(evt) {
        evt && evt.preventDefault();
        this.setState({ showDetailsModal: !this.state.showDetailsModal });
    }

    addressItem(immInsurance, isEmittedByOpenBank) {
        const addressInfoOpenbank = immInsurance.getIn(['livingPlace', 'address']) || '';
        const addressInfoZurich = immInsurance.getIn(['livingPlace', 'zurichAddress']) || '';
        const addressInfo = isEmittedByOpenBank ? addressInfoOpenbank : addressInfoZurich;

        return (
            <OKInformativeListItem
                title={formatText('insuranceConsultiveProductDetails-address')}
                bodyText={addressInfo}
                bodyWordBreak={false}
                className="ok-informative-list-item--height-fix"
            />
        );
    }

    housingDataZurich(immInsurance, isEmittedByOpenBank) {
        const columsList = isEmittedByOpenBank ? 2 : 1;
        return (
            <OKInformativeList
                title={formatText('insuranceConsultiveProductDetails-insuredLivinPlaceData')}
                columns={columsList}
            >
                {this.addressItem(immInsurance, isEmittedByOpenBank)}
            </OKInformativeList>
        );
    }

    housingDataOpenbank(immInsurance, isEmittedByOpenBank) {
        const housingData = formatText('insuranceConsultiveProductDetails-insuredLivinPlaceData');
        const city = formatText('insuranceConsultiveProductDetails-city');
        const cityInfo = immInsurance.getIn(['livingPlace', 'city']);
        const postalCode = formatText('insuranceConsultiveProductDetails-postalCode');
        const postalCodeInfo = immInsurance.getIn(['livingPlace', 'postalCode']) || '';
        const province = formatText('insuranceConsultiveProductDetails-province');
        const provinceInfo = immInsurance.getIn(['livingPlace', 'province']) || '';
        const columsList = isEmittedByOpenBank ? 2 : 1;
        return (
            <OKInformativeList title={housingData} columns={columsList}>
                {this.addressItem(immInsurance, isEmittedByOpenBank)}
                <OKInformativeListItem
                    title={city}
                    bodyText={cityInfo}
                />
                <OKInformativeListItem
                    title={postalCode}
                    bodyText={postalCodeInfo}
                />
                <OKInformativeListItem
                    title={province}
                    bodyText={provinceInfo}
                />
            </OKInformativeList>
        );
    }

    housingDataView(policyComplementaryInformation, isEmittedByOpenBank) {
        return isEmittedByOpenBank ? this.housingDataOpenbank(policyComplementaryInformation, isEmittedByOpenBank) : this.housingDataZurich(policyComplementaryInformation, isEmittedByOpenBank);
    }

    render() {
        const {
            immPolicyDetails,
            immPolicyComplementaryInformation,
            immInsuranceRequestWizard,
            getCoveragesAndPlansData,
            getCoveragesAndPlansDetailsData
        } = this.props;

        const isEmittedByOpenBank = immPolicyComplementaryInformation.get('detailedResponse');

        const insurancePlan = immPolicyComplementaryInformation.get('insurancePlan');
        const propertyUsage = immPolicyComplementaryInformation.get('propertyUsage');
        const isUsagePropertyRentAndBasicPlan = insurancePlan === BASIC && propertyUsage === RENT;

        const seeCoverageDetailButton = isEmittedByOpenBank ? (
            <OKButton
                modifier="link-emphasize"
                onClick={this.handleToggleDetailsModal}
                loading={false}
            >
                {formatText('insuranceConsultiveProductDetails-viewCoveragesDetail')}
            </OKButton>
        ) : null;

        const continentInfo = immPolicyComplementaryInformation.getIn(['insuredValues', 'continent']) || '';
        const formatedContinentInfo = getFormattedString({
            amount: continentInfo,
            currency: EURO_TEXT,
            decimalsLength: 2
        });

        const contentInfo = isUsagePropertyRentAndBasicPlan ? NA : immPolicyComplementaryInformation.getIn(['insuredValues', 'content']) || '';
        const formatedContentInfo = contentInfo === NA ? contentInfo : getFormattedString({
            amount: contentInfo,
            currency: EURO_TEXT,
            decimalsLength: 2
        });

        const takerInfo = immPolicyDetails.getIn(['taker', 'name']);

        return (
            <OKSectionBox
                className="insurance-request-product-detail-description-ok-section-bottom">
                <article>
                    <OKBoxTitle
                        value={formatText('insuranceConsultiveProductDetails-insuranceDetailsTitle')}
                        inline={true}
                    >
                    </OKBoxTitle>
                    <span className="insurance-request-product-detail-description-ok-section-top__button">
                        {seeCoverageDetailButton}
                    </span>
                    <section className="insurance-request-product-detail-description-ok-section-bottom__body">
                        <OKInformativeList
                            title={formatText('insuranceConsultiveProductDetails-insuredValues')}
                            columns={2}
                        >
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-Continent')}
                                bodyText={formatedContinentInfo}
                            />
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-Content')}
                                bodyText={formatedContentInfo}
                            />
                        </OKInformativeList>
                        {this.housingDataView(immPolicyComplementaryInformation, isEmittedByOpenBank)}
                        <OKInformativeList
                            title={formatText('insuranceConsultiveProductDetails-interveners')}
                            columns={1}
                        >
                            <OKInformativeListItem
                                title={formatText('insuranceConsultiveProductDetails-taker')}
                                bodyText={takerInfo}
                            />
                        </OKInformativeList>
                    </section>
                    <InsuranceRequestCoverageDetailModal
                        isOpen={this.state.showDetailsModal}
                        onHandleRequestClose={this.handleToggleDetailsModal}
                        coverage={immInsuranceRequestWizard}
                        policyComplementaryInformation={immPolicyComplementaryInformation}
                        getCoveragesAndPlansDetailsData={getCoveragesAndPlansDetailsData}
                        getCoveragesAndPlansData={getCoveragesAndPlansData}
                        chosenPlan={insurancePlan}
                        homeInsuranceType={immPolicyComplementaryInformation.get('homeInsuranceType')}
                    />
                </article>
            </OKSectionBox>
        );
    }
}

InsuranceRequestProductHomeDetail.propTypes = {
    immInsuranceRequestWizard: PropTypes.object.isRequired,
    immPolicyDetails: PropTypes.object.isRequired,
    immPolicyComplementaryInformation: PropTypes.object.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getCoveragesAndPlansData: PropTypes.func.isRequired
}

module.exports.constructor = InsuranceRequestProductHomeDetail;

module.exports.InsuranceRequestProductHomeDetail = connect(
    state => ({
        immInsuranceRequestWizard: state.insuranceRequestWizard
    }),
    {
        getCoveragesAndPlansDetailsData: insuranceRequestWizardActions.getCoveragesAndPlansDetailsData,
        getCoveragesAndPlansData: insuranceRequestWizardActions.getCoveragesAndPlansData
    }
)(InsuranceRequestProductHomeDetail);